import { OAuthComponent } from './oauth/oauth.component';
import { SharedModule } from "./shared/shared.module";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { DialogModule } from 'primeng/primeng';
import { FormsModule } from "@angular/forms";
import { GrowlModule } from 'primeng/primeng';

// import { AppRoutingModule } from "./app-routing.module";
import { routing } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { RouterModule, Routes } from "@angular/router";
import { CourseModule } from "./course/course.module";
import { CoreModule } from "./core/core.module";
// import { TestModule } from './test/test.module';
import { AboutComponent } from './about/about.component';
import { AboutService } from './about/about.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {OverlayPanelModule} from 'primeng/primeng';

import {
  CanActivateWithLogin,
  CanActivateChildWithLogin,
  CanActivateByStudent,
  CanActivateAllRouter,
  CanActivateTalentRouter
} from './core/services/can-activate-guard';
import { Activity1710Component } from './activity1710/activity1710.component';
import { Activity1710Service } from './activity1710/activity1710.service';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent, AboutComponent, Activity1710Component,
    OAuthComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    DialogModule,
    OverlayPanelModule,
    CarouselModule.forRoot(),
    GrowlModule,
    CoreModule,
    SharedModule,
    routing,
  ],
  providers: [
    CanActivateWithLogin, CanActivateByStudent, CanActivateChildWithLogin,
     CanActivateAllRouter, AboutService, Activity1710Service,
    CanActivateTalentRouter
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/app.module.ts